// El Questro booking strategy.
//
// A site's reserveUrl is the category's own page on elquestro.com.au
// (/stay/{area}/{category}). The page takes the stay and the party in its
// query string (`dateFrom`, `dateTo` as YYYY-MM-DD, `adults`) and opens with
// them filled in: the booking panel quotes the stay with Book Now, or shows
// the park's own refusal ("Cannot stay less than 3 nights", "Unavailable").

import { format } from "date-fns";
import { resolveCheckout } from "./_context.js";

const isoDate = (date) => format(date, "yyyy-MM-dd");

// The booking panel's own default party.
const DEFAULT_ADULTS = 2;

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate, partySize } = ctx;
    const url = new URL(site.reserveUrl);
    url.search = "";
    url.searchParams.set("dateFrom", isoDate(arrivalDate));
    url.searchParams.set("dateTo", isoDate(resolveCheckout(ctx)));
    url.searchParams.set("adults", String(partySize ?? DEFAULT_ADULTS));
    return url.toString();
  },

  // The area's page (/stay/the-station) lists every category the area sells;
  // the reserveUrl is one category's page.
  buildPreviewUrl(site) {
    const url = new URL(site.reserveUrl);
    url.search = "";
    url.pathname = url.pathname.replace(/\/[^/]+\/?$/, "");
    return url.toString();
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as ?dateFrom=<yyyy-MM-dd>.",
        },
        departureDate: {
          status: "required",
          notes:
            "Encoded as &dateTo=<yyyy-MM-dd>; resolved from arrival + minStayLength when not supplied.",
        },
        ref: {
          status: "ignored",
          notes: "site.reserveUrl already is the category's page.",
        },
        partySize: {
          status: "defaulted",
          defaultValue: DEFAULT_ADULTS,
          notes: "Encoded as &adults=<N>; the booking panel's default is 2.",
        },
      },
    };
  },
};
